import { AuthComponentProps } from "../../views/auth/auth"
import { toast } from 'react-toastify';
import { SistemaResponse } from "domain/types/sistema/sistemaResponse";
import { useNavigate } from "react-router-dom";
import AuthenticationContainer from "base/src/containers/authentication/authenticationContainer";
import { AuthenticationProps } from "base/src/view/authentication/authentication";
import { _UserData, UserData, UserDataBaseEnum } from "base/src/infra/storage/localStorage";
import { Redirect, RouteParamters } from "base/src/utils/routeUtil";


export default class AuthContainer {
  public props: AuthComponentProps;
  public searchParams: URLSearchParams
  // eslint-disable-next-line react-hooks/rules-of-hooks
  public navigate = useNavigate();
  public _userData: UserData

  public _AuthenticationContainer: AuthenticationContainer

  constructor(props: AuthComponentProps, searchParams: URLSearchParams) {
    this.searchParams = searchParams
    this.props = props;
    this._userData = _UserData;

    this._AuthenticationContainer = new AuthenticationContainer({ LoginByToken: props.LoginByToken } as AuthenticationProps, searchParams)
  }

  async GetSistema() {
    const sistemaID = this.searchParams.get(RouteParamters.sistemaID);

    if (sistemaID == null) {
      return null;
    }

    this.props.GetSistema(sistemaID)
  }

  async GetParceiroByUrl() {
    this.props.ParceiroByUrl(window.location.host)
  }

  async Redirect(sistema: SistemaResponse | undefined) {
    const token = this._userData.Get<string>(UserDataBaseEnum.Token)

    let url: string = sistema ? sistema?.UrlBase : ""
    const titulo: string | null = sistema ? sistema.UrlBase : null

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      const urlLocal = this.searchParams.get("urlLocal");
      if (urlLocal) {
        url = urlLocal
      }
    }

    /* const redirect = `${url}?token=${token}` */

    //setTimeout(() => {
    toast(`Redirecionando para ${titulo}`, { type: "info" })

    Redirect(url, [{
      key: RouteParamters.token,
      value: token,
    }
    ])
    // }, 2000)
  }

  RedirectToCentral() {
    this.navigate("/central");
  }

  async Login(request: FormData, callBack: () => void) {
    this.props.Login(request, callBack)
  }
}
